import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';

export interface CalendarConfig {
    calendarLinkNewEvent: string;
    calendarLinkWorkWeek: string;
    emailUrl: string;
    maxInitialCalendarEvents: number;
    maxTotalCalendarEvents: number;
    peopleImagesEnabled: boolean;
    resources: CalendarResources;
}

interface CalendarResources {
    brandOutlookWeb: string;
    calendarLocationAriaLabel: string;
    calendarSectionTitle: string;
    emailOrganizerTitle: string;
    emailOrganizerAriaLabel: string;
    eventAllDayString: string;
    eventEndString: string;
    eventStartString: string;
    joinSkypeTitle: string;
    locationColumnHeader: string;
    navigateToDayAriaLabel: string;
    newEventButton: string;
    newEventLinkAriaLabel: string;
    noEventsDayTitle: string;
    noEventsDaySubtitle: string;
    noEventsLeftTodayTitle: string;
    noEventsLeftTodaySubtitle: string;
    noEventsWeekTitle: string;
    noEventsWeekSubtitle: string;
    openCalendarTitle: string;
    openCalendarLinkAriaLabel: string;
    openInCalendarTitle: string;
    openInCalendarLinkAriaLabel: string;
    organizerColumnHeader: string;
    showLessCalendarEventsAriaLabel: string;
    showLessCalendarEventsUpdateAriaLabel: string;
    showMoreCalendarEventsAriaLabel: string;
    showMoreCalendarEventsUpdateAriaLabel: string;
}

@Injectable({
    providedIn: 'root'
})
export class CalendarConfigService {
    public readonly config: CalendarConfig;

    constructor(
        configParserService: ConfigParserService,
        clientStartupConfigService: ClientStartupConfigService
    ) {
        this.config = configParserService.parse<CalendarConfig>('calendarConfig');
        if (this.config) {
            // Disable people images from displaying during automated tests so that the screenshots are consistent.
            this.config.peopleImagesEnabled = this.config.peopleImagesEnabled && !clientStartupConfigService.config.automatedTestRunning;
        }
    }
}
